export default "__VITE_ASSET__DESr$DFR__"